import { z } from 'zod';
import { OAuthAccessDeniedCode } from '@/api/error-codes';

export const loginSearchSchema = z.object({
  /**
   * Authentication error to display to the user on after log-out.
   */
  aerr: z
    .enum(['coop'])
    .optional()
    // Catch other string-like auth errors from previous versions of the app for a while...
    .catch(undefined),
  /**
   * Used for redirection to Auth0's universal login.
   */
  sso_connection: z.string().optional(),
  /**
   * Used for redirection to Auth0's universal login.
   */
  sso_login_hint: z.string().optional(),
  /**
   * Return relative URL to forward to /login?return_to=[url] once Auth logout occurs.
   */
  return_to: z.string().optional(),
});

export type LoginSearchSchema = z.infer<typeof loginSearchSchema>;

export const logoutSearchSchema = loginSearchSchema.extend({
  /**
   * Authentication error to display to the user on after log-out.
   */
  aerr: z
    .enum(['unknown', 'expired', 'invalid', 'coop', ...Object.values(OAuthAccessDeniedCode)])
    .optional()
    .catch('unknown'),
});

export type LogoutSearchSchema = z.infer<typeof logoutSearchSchema>;
